import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../common/Header.js";
import $ from "jquery";
import { ReactSession } from "react-client-session";
import "react-slideshow-image/dist/styles.css";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import API_BASE_URL from "../../config/constants.js";
import { common_icons } from "../../config/imagedata/small_icons.js";
import { final_images } from "../../config/imagedata/pages/final_images.js";
import DiscountedPlan from "./final/DiscountedPlan.js";
import MainPaymentPlan from "./final/MainPaymentPlan.js";
import { DataLayer } from "../common/Function.js";
import { freeEmails } from "../common/StringData.js";

const componentLoaders = {
  v_1: () => import("../../layouts/checkout/checkout_layout_1/FinalLayout.js"),
  v_2: () => import("../../layouts/checkout/checkout_layout_2/FinalLayout.js"),
  v_3: () => import("../../layouts/checkout/checkout_layout_3/FinalLayout.js"),
  v_4: () => import("../../layouts/checkout/checkout_layout_4/FinalLayout.js"),
  v_5: () => import("../../layouts/checkout/checkout_layout_5/FinalLayout.js"),
  v_6: () => import("../../layouts/checkout/checkout_layout_6/FinalLayout.js"),
  v_7: () => import("../../layouts/checkout/checkout_layout_7/FinalLayout.js"),
  v_8: () => import("../../layouts/checkout/checkout_layout_8/FinalLayout.js"),
  v_9: () => import("../../layouts/checkout/checkout_layout_9/FinalLayout.js"),
};

const Final = () => {
  ReactSession.setStoreType("localStorage");
  const finalParams = useParams();
  let history = useNavigate();
  let result = useLocation();
  let currentURL = window.location.href;
  var url = new URL(currentURL);

  var baseUrl =
    url.protocol + "//" + url.hostname + (url.port ? ":" + url.port : "");

  const currency_symbols = { us: "$", uk: "£", ca: "$", aus: "$" };
  const [pageLayoutVersion, setPageLayoutVersion] = useState(
    JSON.parse(ReactSession.get("ketobalanced_options"))?.survey?.design
      ?.paymentPage
  );

  const [pageLayoutOption, setPageLayoutOption] = useState({
    FinalLayout: null,
    OfferPopup: null,
    PaymentPopup: null,
  });

  useEffect(() => {
    const loadComponents = async () => {
      const loader =
        componentLoaders[pageLayoutVersion] || componentLoaders["v_2"];
      // const loader = componentLoaders["v_3"];
      const module = await loader();

      setPageLayoutOption({
        FinalLayout: React.lazy(() =>
          Promise.resolve({ default: module.default })
        ),
        OfferPopup: React.lazy(() =>
          Promise.resolve({ default: module.OfferPopup })
        ),
        PaymentPopup: React.lazy(() =>
          Promise.resolve({ default: module.PaymentPopup })
        ),
      });
    };

    loadComponents();
  }, [pageLayoutVersion]);

  useEffect(() => {
    if (finalParams?.version && finalParams?.version != "plan") {
      setPageLayoutVersion(finalParams?.version);
    }
  }, []);

  const { FinalLayout, OfferPopup, PaymentPopup } = pageLayoutOption;

  /* custom timer */
  const Ref = useRef(null);

  // The state for our timer
  const [timer, setTimer] = useState({
    hours: "00",
    minutes: "14",
    seconds: "59",
  });
  const [urlPre, setUrlPre] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isPgProcessing, setIsPgProcessing] = useState(false);
  const [Bearer, setBearer] = useState("");

  // time runner start--------------------------------

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      const TimerData = {
        hours: hours > 9 ? hours : "0" + hours,
        minutes: minutes > 9 ? minutes : "0" + minutes,
        seconds: seconds > 9 ? seconds : "0" + seconds,
      };
      setTimer(TimerData);
    }
  };

  const clearTimer = (e) => {
    setTimer({
      hours: "00",
      minutes: "25",
      seconds: "00",
    });

    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 1500);
    return deadline;
  };

  //----------------time runner----------------------------ends

  const [count, setCount] = useState(true);
  let [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  // const [offerModal, setOfferModal] = useState("modelinfo-wrap");
  const [discountModal, setDiscountModal] = useState("dscntmodelinfo-wrap");
  const [sectionType, setSectionType] = useState("default"); // discountedPlan ,default
  const [genderContent, setGenderContent] = useState(""); // Men
  const [weightContent, setWeightContent] = useState("");
  const [weightContentType, setWeightContentType] = useState("");

  const common_icons_array = useMemo(() => common_icons);
  const final_array = useMemo(() => final_images, []);
  const starObject = [
    common_icons_array["star_5"],
    common_icons_array["star_5"],
    common_icons_array["star_4"],
    common_icons_array["three_point_5"],
    common_icons_array["star_5"],
    common_icons_array["star_4"],
  ];

  //----------testimonial---slide-----ends-------------------

  useEffect(() => {
    if (window.location.pathname.split("/")[1] === "men") {
      setUrlPre("/men");
    } else if (window.location.pathname.split("/")[1] === "women") {
      setUrlPre("/women");
    } else if (window.location.pathname.split("/")[1] === "over40") {
      setUrlPre("/over40");
    } else {
      setUrlPre("");
    }

    clearTimer(getDeadTime());

    setTimeout(() => {
      setIsLoading(true); // Set loading state to false
    }, 250);

    if (localStorage.getItem("state")) {
      let base64_data = JSON.parse(
        atob(localStorage.getItem("state").slice(6, -4))
      );
      if (result.state === null) {
        history(urlPre + "/final.php", { state: base64_data });
      }
    }

    //----------------- gender filtration------------------------
    if (ReactSession.get("ketobalanced_options")) {
      const genderList = JSON.parse(ReactSession.get("ketobalanced_options"))
        .survey.surveyItems[0].categoryItems;
      const genderName = genderList.filter(
        (genderItem) => genderItem.itemId == ReactSession.get("gender")
      );
      setGenderContent(genderName[0].name);
    }

    //-------------- gender filtration-----------------------------

    //----------------- weight filtration------------------------
    setWeightContent(
      ReactSession.get("target") == ""
        ? ReactSession.get("target_1")
        : ReactSession.get("target")
    );
    setWeightContentType(ReactSession.get("ttype"));
    //-------------- weight filtration-----------------------------

    const toggleVisibility = () => {
      if (window.pageYOffset > 700) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    // Clean-up the event listener on unmount
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  /* customer timer */

  const [data, setData] = useState([]);
  const [Dplandata, setDplanData] = useState([]);
  const [paymentList, setPaymentList] = useState({
    paypal: false,
    payglocal: false,
    stripe: false,
    squareup: true,
  });
  const [feedBackList, set_feedBackList] = useState([]);
  const [clientid, setClientId] = useState("");
  const [discounted_pcr_before, set_discounted_pcr_before] = useState(null);
  const [discounted_pcr, set_discounted_pcr] = useState(null);

  const [notifyMessage, set_notifyMessage] = useState(null);

  const [isOpen, setIsOpen] = React.useState();
  const [isOpenOffer, setIsOpenOffer] = React.useState();
  const [billedText, setbilledText] = React.useState();
  const [billedPrice, setbilledPrice] = React.useState();
  const [billedCredits, setbilledCredits] = React.useState();
  const [billedDiscount, setbilledDiscount] = React.useState(0);
  const [planIndexId, setPlanIndexId] = React.useState(1);
  const [PlanId, setPlanId] = React.useState(1);

  const GetData = () => {
    try {
      if (result.state.responce && result.state.responce.plan) {
        setClientId(result.state.responce.CLIENT_ID);
        setBearer(result.state.responce.accessToken);
        result.state.responce.plan.forEach((planRow, index) => {
          if (planRow.isTrue === true && index === planIndexId) {
            setbilledText(planRow.name);
            setbilledPrice(planRow.price);
            setbilledDiscount(
              ((planRow.price - planRow.credits) * 100) / planRow.price
            );
            setbilledCredits(planRow.credits);
            setPlanId(planRow.id);
          } else {
            planRow.isTrue = false;
          }
        });

        //Dplan false
        result.state.responce.discountedplan.forEach((DplanRow, index) => {
          if (DplanRow.isTrue === true && index === planIndexId) {
            set_discounted_pcr_before(DplanRow.discounted_pcr_before);
            set_discounted_pcr(DplanRow.discounted_pcr);
          } else {
            DplanRow.isTrue = false;
          }
        });

        // additional code for cookie addition
        document.cookie =
          "encryptEmail=" + result.state.responce.encryptEmail + "; path=/";
        // console.log(result.state.responce.valueAdded);
      } else {
        setbilledPrice(0);
        setbilledDiscount(0);
        setbilledCredits(0);
      }

      if (result.state.responce) {
        set_notifyMessage(result.state.responce.caseStudy.message);
        setData(result.state.responce.plan);
        setDplanData(result.state.responce.discountedplan);
        // result.state.responce.paymentList.square = true;
        setPaymentList(result.state.responce.paymentList);
        var topTitle1 = result.state.responce.caseStudy.topTitle1;
        $("#topTitle1").html(topTitle1);
        set_feedBackList(result.state.responce.caseStudy["feedBack"].list);
      }
    } catch (err) {
      // alert("Please process all steps correctly...");
      history("/email.html"); //static temp on 16-Nov-2023
      console.log(err);
    }
  };

  const PayGlocalHandle = async (event) => {
    const freeEmailsVar = freeEmails;

    if (freeEmailsVar.includes(ReactSession.get("email"))) {
      // console.log(freeEmailsVar.includes(ReactSession.get("email")));
      history("/register-form.html");
      return false;
    }

    setIsPgProcessing(true);

    // var getway_api = "";
    if (event == "stickypaypal") {
      var getway_api =
        API_BASE_URL + "/pro/payment/stk/log/paypaloptioninitiate";
    } else if (event == "squareup") {
      var getway_api = API_BASE_URL + "/pro/p4/psqup/initiate";
    } else {
      var getway_api = API_BASE_URL + "/pro/p3/pg/initiate";
    }

    let planid = PlanId;
    const postOption = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Bearer,
      },
      body: JSON.stringify({
        planId: planid,
        callback: baseUrl + "/callback/pg/" + event,
      }),
    };
    fetch(getway_api, postOption)
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          console.log(result.redirectUrl);
          window.location.href = result.redirectUrl;
          // setIsPgProcessing(false);
        } else if (result.error) {
          alert(result.error.message);
          setIsPgProcessing(false);
        }
      })
      .catch((err) => {
        setIsPgProcessing(false);
        console.log(err);
      });
  };

  useEffect(() => {
    GetData();
    setTimeout(() => {
      history(urlPre + "/email.html");
    }, 1000 * 60 * 25);
  }, []);

  useEffect(() => {
    const dataLayer_res = DataLayer({
      event: "finalStepView",
      stage: "Checkout Final Plan Page",
    });
  }, []);

  // ================== Bootstrap Modal======================

  const showModal = (element) => {
    setPlanIndexId(element);

    if (sectionType === "default") {
      data.forEach((element, indexID2) => {
        data[indexID2].isTrue = false;
      });
      data[element].isTrue = true;
    } else {
      Dplandata.forEach((element, indexID2) => {
        Dplandata[indexID2].isTrue = false;
      });
      Dplandata[element].isTrue = true;
    }

    setIsOpen(true);
  };
  const hideModal = (element2) => {
    setIsOpen(false);
  };

  const hideModalOffer = (element2) => {
    setIsOpenOffer(false);
  };

  if (isLoading === false || isPgProcessing === true) {
    return <>{/* <Loader /> */}</>;
  }
  // console.log(paymentList);
  // ================== Bootstrap Modal======================
  // console.log(result.state);

  if (!FinalLayout || !OfferPopup || !PaymentPopup) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <FinalLayout
        notifyMessage={notifyMessage}
        final_array={final_array}
        showModal={showModal}
        planIndexId={planIndexId}
        sectionType={sectionType}
        genderContent={genderContent}
        weightContent={weightContent}
        weightContentType={weightContentType}
        timer={timer}
        MainPaymentPlan={MainPaymentPlan}
        data={data}
        setbilledText={setbilledText}
        setbilledPrice={setbilledPrice}
        setbilledCredits={setbilledCredits}
        setbilledDiscount={setbilledDiscount}
        setPlanIndexId={setPlanIndexId}
        setPlanId={setPlanId}
        currency_symbols={currency_symbols}
        billedCredits={billedCredits}
        common_icons_array={common_icons_array}
        feedBackList={feedBackList}
        starObject={starObject}
        Link={Link}
        DiscountedPlan={DiscountedPlan}
        discountModal={discountModal}
        discounted_pcr_before={discounted_pcr_before}
        discounted_pcr={discounted_pcr}
        common_icons={common_icons}
        Dplandata={Dplandata}
        isVisible={isVisible}
        scrollToTop={scrollToTop}
        Popup={Popup}
        isOpen={isOpen}
        Header={Header}
      />
      <PaymentPopup
        isOpen={isOpen}
        hideModal={hideModal}
        common_icons_array={common_icons_array}
        billedText={billedText}
        currency_symbols={currency_symbols}
        billedPrice={billedPrice}
        billedDiscount={billedDiscount}
        billedCredits={billedCredits}
        paymentList={paymentList}
        PayPalScriptProvider={PayPalScriptProvider}
        clientid={clientid}
        PayPalButtons={PayPalButtons}
        API_BASE_URL={API_BASE_URL}
        Bearer={Bearer}
        history={history}
        urlPre={urlPre}
        PayGlocalHandle={PayGlocalHandle}
        final_array={final_array}
        PlanId={PlanId}
      />
      <OfferPopup
        isOpenOffer={isOpenOffer}
        hideModalOffer={hideModalOffer}
        final_array={final_array}
        setDiscountModal={setDiscountModal}
        setSectionType={setSectionType}
        setIsOpenOffer={setIsOpenOffer}
      />
    </>
  );
};
export default React.memo(Final);
